export default function CircleCheckIcon() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M54.375 30C54.375 43.4625 43.4625 54.375 30 54.375C16.5375 54.375 5.625 43.4625 5.625 30C5.625 16.5375 16.5375 5.625 30 5.625C43.4625 5.625 54.375 16.5375 54.375 30Z" stroke="#128A09" strokeWidth="2.5" />
      <path d="M39.2787 24.1577L27.3487 36.0902L20.7188 29.4627" stroke="#128A09" strokeWidth="2.5" />
    </svg>
  )
}